module.exports = __webpack_public_path__ + "static/media/team-member3.93130ff6.png";